import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('user_to_qnos_mapping')
export class UserToQnosMappingEntity {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    @Column("int", { name: "class" })
    class: number;

    @Column("int", { name: "subject" })
    subject: number;

    @Column("int", { name: "chapter" })
    chapter: number;

    @Column("int", { name: "topic" })
    topic: number;

    @Column("varchar", { name: "user" })
    user: string;


    @Column("int", { name: "qno_s" })
    qnos: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
}